var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTataLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "&ns_svg;",
    xmlnsXlink: "&ns_xlink;",
    width: 451.316,
    height: 414.473,
    viewBox: "0 0 451.316 414.473",
    overflow: "visible",
    enableBackground: "new 0 0 451.316 414.473",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#486AAE",
    points: "14.616,286.732 116.23,286.732 116.23,317.654 87.079,317.654 87.079,391.969 44.737,391.969  44.737,317.654 14.616,317.654  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#486AAE",
    points: "167.692,329.252 146.298,391.969 105.635,391.969 145.516,286.732 189.677,286.732  230.519,391.969 189.356,391.969  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#486AAE",
    points: "220.805,286.732 322.415,286.732 322.415,317.654 293.273,317.654 293.273,391.969  250.933,391.969 250.933,317.654 220.805,317.654  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#486AAE",
    points: "373.895,329.252 352.493,391.969 311.83,391.969 351.724,286.732 395.872,286.732 436.7,391.969  395.552,391.969  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#486AAE",
    d: "M375.394,93.432c-3.794-7.461-8.791-14.612-15.007-21.318 c-13.969-15.077-33.678-27.623-57.002-36.276c-23.516-8.72-50.338-13.334-77.595-13.334s-54.079,4.614-77.583,13.334 c-23.336,8.654-43.046,21.2-57.015,36.276C84.98,78.819,79.967,85.98,76.174,93.445c30.365-7.343,82.306-17.038,130.534-18.063 c4.652-0.1,7.855,1.39,9.964,4.063c2.569,3.255,2.376,14.858,2.313,20.049l-1.371,134.17c2.716,0.09,5.445,0.148,8.176,0.148 c2.754,0,5.498-0.045,8.214-0.135l-1.371-134.184c-0.071-5.19-0.27-16.794,2.308-20.049c2.114-2.672,5.306-4.162,9.957-4.063 C293.106,76.398,345.035,86.095,375.394,93.432"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#486AAE",
    d: "M381.877,110.88c-44.442-10.047-74.121-11.905-103.405-13.53 c-25.526-1.419-25.859,7.696-23.311,25.115c0.167,1.063,0.372,2.403,0.615,3.931c8.562,50.712,19.224,94.352,21.056,101.759 c62.23-14.225,107.109-53.664,107.109-99.994C383.941,122.327,383.236,116.547,381.877,110.88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#486AAE",
    d: "M196.443,122.465c2.551-17.418,2.224-26.534-23.299-25.115 c-29.294,1.625-58.98,3.482-103.439,13.536c-1.358,5.667-2.072,11.44-2.072,17.274c0,20.024,8.146,39.4,23.56,56.047 c13.969,15.077,33.679,27.623,57.015,36.282c8.446,3.127,17.359,5.69,26.54,7.74c1.723-6.939,12.63-51.487,21.285-103.106 C196.193,124.134,196.341,123.221,196.443,122.465"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTataLogo);
export default __webpack_public_path__ + "static/media/tata_logo.49acb07eac35607b7b8440b256c81e59.svg";
export { ForwardRef as ReactComponent };